<p>merge-tag-picker-input-base works!</p>
